<template>
	<div>
		<div class="row">
			<div class="col-md-4">
				Delivery Methods:
				<div id="deliverMethods" class="checkbox" style="margin:5px 0 10px 0; padding-top:0px;">
					<label style="margin:0;">
						<input type="checkbox" value="1" v-model="rule.settings.send_email"> Email<br/>
						<input type="checkbox" value="1" v-model="rule.settings.send_text"> Text message<br/>
						<input type="checkbox" value="1" v-model="rule.settings.send_feed"> Feed<br/>
					</label>
				</div>
				
				<input type="text" class="redemptionSubject form-control" placeholder="Subject..." v-model="rule.settings.subject"/><br/>
				<textarea class="redemptionMessage form-control" placeholder="Message..." v-model="rule.settings.message"></textarea>
			</div>
			<div class="col-md-4">
				Total Redemptions:<br/>
				<input type="number" class="redemptionsNeeded form-control" min="1" value="1" v-model="rule.settings.redemptions_needed"/><br/>
				
				From Only These: (not required)<br/>
				<multiselect
					v-model="productOptions"
					:options="filteredProducts"
					:close-on-select="false"
					:hide-selected="true"
					multiple
					track-by="id"
					label="name"
					group-values="options"
					group-label="group_name"
					:internal-search="false"
					@search-change="doSearch"
				>
					<template slot="tag" slot-scope="props">
						<span class="multiselect__tag" :title="props.option.name">
							<small class="multiselect__tag-small">{{ props.option.venueName }}</small>
							<p class="multiselect__tag-text">{{ props.option.name }}</p>
							<i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon"></i>
						</span>
					</template>
				</multiselect><br/>
				
				Redemptions Made After:<br/>
				<date-picker v-model="startDate"></date-picker><br/>
				
				Redemptions Made Before:<br/>
				<date-picker v-model="endDate"></date-picker><br/>
				
				<div class="checkbox">
					<label>
						<input type="checkbox" class="onePerVenue" v-model="rule.settings.one_per_venue">
						Only count one redemption per venue
					</label>
				</div>
			</div>
			<div class="col-md-4">
				Add Products:<br/>
				<multiselect
					v-model="productIds"
					:options="filteredProducts"
					:close-on-select="false"
					multiple
					track-by="id"
					label="name"
					group-values="options"
					group-label="group_name"
					:internal-search="false"
					@search-change="doSearch"
				>
					<template slot="tag" slot-scope="props">
						<span class="multiselect__tag" :title="props.option.name">
							<small class="multiselect__tag-small">{{ props.option.venueName }}</small>
							<p class="multiselect__tag-text">{{ props.option.name }}</p>
							<i aria-hidden="true" tabindex="1" @click="props.remove(props.option)" class="multiselect__tag-icon"></i>
						</span>
					</template>
				</multiselect>
				
				<div class="checkbox">
					<label>
						<input type="checkbox" class="onePerVenue" v-model="rule.settings.add_outside_deal">
						Add products outside the deal
					</label>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			products: {
				type: Array,
				required: true
			},
			rule: {
				type: Object,
				required: true
			},
		},
		data() {
			return {
				localProducts: null,
			};
		},
		computed: {
			filteredProducts: {
				get() {
					return this.localProducts === null ? this.products : this.localProducts;
				},
				set(v) {
					this.localProducts = v;
				}
			},
			startDate: {
				get() {
					return Bandwango.dateToLocal(this.rule.settings.start_date_time);
				},
				set(v) {
					this.$set(this.rule.settings, 'start_date_time', Bandwango.dateToUtc(v));
				}
			},
			endDate: {
				get() {
					return Bandwango.dateToLocal(this.rule.settings.end_date_time);
				},
				set(v) {
					this.$set(this.rule.settings, 'end_date_time', Bandwango.dateToUtc(v));
				}
			},
			productIds: {
				get() {
					let values = [];
					this.products.forEach((group) => {
						let filtered = group.options.filter((option) => {
							return this.rule.settings.product_ids.map(Number).indexOf(option.id) > -1; 
						});
						if (filtered.length > 0) values = values.concat(filtered);
					});
					return values;
				},
				set(newVal) {
					this.rule.settings.product_ids = newVal.map((v) => v.id);
				}
			},
			productOptions: {
				get() {
					let values = [];
					this.products.forEach((group) => {
						let filtered = group.options.filter((option) => {
							return this.rule.settings.product_options.map(Number).indexOf(option.id) > -1; 
						});
						if (filtered.length > 0) values = values.concat(filtered);
					});
					return values;
				},
				set(newVal) {
					this.rule.settings.product_options = newVal.map((v) => v.id);
				}
			},
		},
		methods: {
			doSearch(query) {
				if (query === '') this.filteredProducts = this.products;
				else {
					const options = {
						ignoreFieldNorm: true,
						ignoreLocation: true,
						threshold: 0.0,
						keys: ['group_name', 'options.name', 'options.categories.name']
					}
					const fuse = new Fuse(this.products, options);
					this.filteredProducts = fuse.search(query).map(res => res.item);
				}
			},
		},
	}
</script>